<template>
  <div class="ProjectBasketThumbnail" style="position:relative;">
    <div
      v-if="!detailed"
      @click="$emit('delete')"
      class="delete is-danger is-small"
      style="position:absolute; z-index: 1; right: -4px; top: -4px;"
    ></div>
    <api-picture-cropped
      :ratio="16 / 9"
      :picture-id="item.main_image"
    ></api-picture-cropped>
  </div>
</template>

<script>
import ApiPictureCropped from "../Layout/ApiPictureCropped";

export default {
  name: "ProjectBasketThumbnail",
  components: { ApiPictureCropped },
  props: {
    item: {},
    detailed: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.ProjectBasketThumbnail {
  padding: 2px;
  border-radius: 2px;
  border: 1px solid #ddd;
  background: white;
  &__controls {
    display: flex;
    justify-content: space-between;
    padding: 2px;
    font-size: 11px;
  }
}
</style>
